module.exports = __webpack_public_path__ + "img/icon_fanjian.35fdd226.svg";